{
  "REPORT": {
    "HEADER": "Beszélgetések",
    "LOADING_CHART": "Táblázat adatok betöltése...",
    "NO_ENOUGH_DATA": "Nem érkezett elég adat hogy jelentést generáljunk, kérjük próbáld később.",
    "DOWNLOAD_AGENT_REPORTS": "Ügynök jelentések letöltése",
    "DATA_FETCHING_FAILED": "Sikertelen adatlekérés, kérlek próbáld újra később.",
    "SUMMARY_FETCHING_FAILED": "Sikertelen összefoglaló lekérés, kérlek próbáld újra később.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Beszélgetések",
        "DESC": "( Teljes )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Beérkező üznetek",
        "DESC": "( Teljes )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Kimenő üzenetek",
        "DESC": "( Teljes )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Első reakció idő",
        "DESC": "( Átlag )",
        "INFO_TEXT": "A számításhoz felhasznált beszélgetések száma:",
        "TOOLTIP_TEXT": "Az első reakció ideje {metricValue} ({conversationCount} beszélgetés alapján)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Megoldási idő",
        "DESC": "( Átlag )",
        "INFO_TEXT": "A számításhoz felhasznált beszélgetések száma:",
        "TOOLTIP_TEXT": "A megoldási idő {metricValue} ({conversationCount} beszélgetés alapján)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Megoldások száma",
        "DESC": "( Teljes )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Megoldások száma",
        "DESC": "( Teljes )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Átadások száma",
        "DESC": "( Teljes )"
      },
      "REPLY_TIME": {
        "NAME": "Vevő várakozási idő",
        "TOOLTIP_TEXT": "A várakozási idő {metricValue} ({conversationCount} válasz alapján)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "Ma",
      "YESTERDAY": "Tegnap",
      "LAST_7_DAYS": "Utolsó 7 nap",
      "LAST_30_DAYS": "Utolsó 30 nap",
      "THIS_MONTH": "Ez a hónap",
      "LAST_MONTH": "Előző hónap",
      "LAST_3_MONTHS": "Elmúlt 3 hónapban",
      "LAST_6_MONTHS": "Elmúlt 6 hónapban",
      "LAST_YEAR": "Elmúlt 1 évben",
      "CUSTOM_DATE_RANGE": "Egyedi időszak"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Alkalmaz",
      "PLACEHOLDER": "Dátumtartomány kiválasztása"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Csoportosítás",
    "DURATION_FILTER_LABEL": "Időszak",
    "GROUPING_OPTIONS": {
      "DAY": "Nap",
      "WEEK": "Hét",
      "MONTH": "Hónap",
      "YEAR": "Év"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Nap"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Nap"
      },
      {
        "id": 2,
        "groupBy": "Hét"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Nap"
      },
      {
        "id": 2,
        "groupBy": "Hét"
      },
      {
        "id": 3,
        "groupBy": "Hónap"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      },
      {
        "id": 3,
        "groupBy": "Month"
      }
    ],
    "BUSINESS_HOURS": "Nyitvatartás",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Szűrő törlése",
      "EMPTY_LIST": "Nincs találat"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Beszélgetések: {count}",
      "RESULT_COUNT_MESSAGE": "Üzenetek: {count}",
      "EMPTY": "Ehhez az oszlophoz nem található rekord.",
      "ERROR": "A rekordok betöltése nem sikerült. Próbálja újra.",
      "LOAD_MORE": "Továbbiak betöltése",
      "PREVIOUS_BUCKET": "Előző oszlop",
      "NEXT_BUCKET": "Következő oszlop",
      "UNKNOWN_CONTACT": "Ismeretlen kontakt",
      "UNKNOWN_INBOX": "Ismeretlen fiók",
      "UNASSIGNED_AGENT": "Nincs hozzárendelve",
      "NO_MESSAGE_CONTENT": "Nincs üzenettartalom",
      "MESSAGE_CREATED_AT": "Üzenet létrehozva: {time}",
      "EVENT_OCCURRED_AT": "Esemény ideje: {time}",
      "INCOMING_MESSAGE": "Bejövő üzenet",
      "OUTGOING_MESSAGE": "Kimenő üzenet",
      "VIEW_ALL": "Megtekintés a beszélgetésekben",
      "VIEW_ALL_LIMIT": "Csak a legfeljebb {limit} beszélgetést tartalmazó oszlopok nyithatók meg a beszélgetéslistában.",
      "HIDDEN_COUNT": "Nem látható, mert nem tagja a fiókjuknak: {count}"
    },
    "PAGINATION": {
      "RESULTS": "{start}–{end} / {total} találat",
      "PER_PAGE_TEMPLATE": "{size} / oldal"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Ügynök áttekintés",
    "DESCRIPTION": "Kövesse nyomon az ügynökök teljesítményét a fő mutatókkal: beszélgetések, válaszidők, megoldási idők és megoldott ügyek. További részletekért kattintson az ügynök nevére.",
    "LOADING_CHART": "Táblázat adatok betöltése...",
    "NO_ENOUGH_DATA": "Nem érkezett elég adat hogy jelentést generáljunk, kérjük próbáld később.",
    "DOWNLOAD_AGENT_REPORTS": "Ügynök jelentések letöltése",
    "FILTER_DROPDOWN_LABEL": "Ügynök kiválasztása",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Beszélgetések",
        "DESC": "( Teljes )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Beérkező üznetek",
        "DESC": "( Teljes )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Kimenő üzenetek",
        "DESC": "( Teljes )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Első reakció idő",
        "DESC": "( Átlag )",
        "INFO_TEXT": "A számításhoz felhasznált beszélgetések száma:",
        "TOOLTIP_TEXT": "Az első reakció ideje {metricValue} ({conversationCount} beszélgetés alapján)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Megoldási idő",
        "DESC": "( Átlag )",
        "INFO_TEXT": "A számításhoz felhasznált beszélgetések száma:",
        "TOOLTIP_TEXT": "A megoldási idő {metricValue} ({conversationCount} beszélgetés alapján)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Megoldások száma",
        "DESC": "( Teljes )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Utolsó 7 nap"
      },
      {
        "id": 1,
        "name": "Utolsó 30 nap"
      },
      {
        "id": 2,
        "name": "Elmúlt 3 hónapban"
      },
      {
        "id": 3,
        "name": "Elmúlt 6 hónapban"
      },
      {
        "id": 4,
        "name": "Elmúlt 1 évben"
      },
      {
        "id": 5,
        "name": "Egyedi időszak"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Alkalmaz",
      "PLACEHOLDER": "Dátumtartomány kiválasztása"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Címkék áttekintése",
    "DESCRIPTION": "Kövesse nyomon a címkék teljesítményét kulcsfontosságú mutatókkal, például beszélgetésekkel, válaszidőkkel, megoldási időkkel és megoldott esetekkel.",
    "LOADING_CHART": "Táblázat adatok betöltése...",
    "NO_ENOUGH_DATA": "Nem érkezett elég adat hogy jelentést generáljunk, kérjük próbáld később.",
    "DOWNLOAD_LABEL_REPORTS": "Címkejelentések letöltése",
    "FILTER_DROPDOWN_LABEL": "Cimke választása",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Beszélgetések",
        "DESC": "( Teljes )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Beérkező üznetek",
        "DESC": "( Teljes )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Kimenő üzenetek",
        "DESC": "( Teljes )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Első reakció idő",
        "DESC": "( Átlag )",
        "INFO_TEXT": "A számításhoz felhasznált beszélgetések száma:",
        "TOOLTIP_TEXT": "Az első reakció ideje {metricValue} ({conversationCount} beszélgetés alapján)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Megoldási idő",
        "DESC": "( Átlag )",
        "INFO_TEXT": "A számításhoz felhasznált beszélgetések száma:",
        "TOOLTIP_TEXT": "A megoldási idő {metricValue} ({conversationCount} beszélgetés alapján)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Megoldások száma",
        "DESC": "( Teljes )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Utolsó 7 nap"
      },
      {
        "id": 1,
        "name": "Utolsó 30 nap"
      },
      {
        "id": 2,
        "name": "Elmúlt 3 hónapban"
      },
      {
        "id": 3,
        "name": "Elmúlt 6 hónapban"
      },
      {
        "id": 4,
        "name": "Elmúlt 1 évben"
      },
      {
        "id": 5,
        "name": "Egyedi időszak"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Alkalmaz",
      "PLACEHOLDER": "Dátumtartomány kiválasztása"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Beérkezett üzenetek áttekintése",
    "DESCRIPTION": "Tekintse át a postafiókok teljesítményét egy helyen a fő mutatókkal: beszélgetések, válaszidők, megoldási idők és megoldott ügyek. További részletekért kattintson a postafiók nevére.",
    "LOADING_CHART": "Táblázat adatok betöltése...",
    "NO_ENOUGH_DATA": "Nem érkezett elég adat hogy jelentést generáljunk, kérjük próbáld később.",
    "DOWNLOAD_INBOX_REPORTS": "Beérkezett üzenetek letöltése",
    "FILTER_DROPDOWN_LABEL": "Válassz egy fiókot",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Beszélgetések",
        "DESC": "( Teljes )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Beérkező üznetek",
        "DESC": "( Teljes )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Kimenő üzenetek",
        "DESC": "( Teljes )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Első reakció idő",
        "DESC": "( Átlag )",
        "INFO_TEXT": "A számításhoz felhasznált beszélgetések száma:",
        "TOOLTIP_TEXT": "Az első reakció ideje {metricValue} ({conversationCount} beszélgetés alapján)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Megoldási idő",
        "DESC": "( Átlag )",
        "INFO_TEXT": "A számításhoz felhasznált beszélgetések száma:",
        "TOOLTIP_TEXT": "A megoldási idő {metricValue} ({conversationCount} beszélgetés alapján)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Megoldások száma",
        "DESC": "( Teljes )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Utolsó 7 nap"
      },
      {
        "id": 1,
        "name": "Utolsó 30 nap"
      },
      {
        "id": 2,
        "name": "Elmúlt 3 hónapban"
      },
      {
        "id": 3,
        "name": "Elmúlt 6 hónapban"
      },
      {
        "id": 4,
        "name": "Elmúlt 1 évben"
      },
      {
        "id": 5,
        "name": "Egyedi időszak"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Alkalmaz",
      "PLACEHOLDER": "Dátumtartomány kiválasztása"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Csapat áttekintés",
    "DESCRIPTION": "Kapjon áttekintést a csapat teljesítményéről a fő mutatókkal: beszélgetések, válaszidők, megoldási idők és megoldott ügyek. További részletekért kattintson a csapat nevére.",
    "LOADING_CHART": "Táblázat adatok betöltése...",
    "NO_ENOUGH_DATA": "Nem érkezett elég adat hogy jelentést generáljunk, kérjük próbáld később.",
    "DOWNLOAD_TEAM_REPORTS": "Csapat riport letöltése",
    "FILTER_DROPDOWN_LABEL": "Csapat kiválasztása",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Beszélgetések",
        "DESC": "( Teljes )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Beérkező üznetek",
        "DESC": "( Teljes )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Kimenő üzenetek",
        "DESC": "( Teljes )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Első reakció idő",
        "DESC": "( Átlag )",
        "INFO_TEXT": "A számításhoz felhasznált beszélgetések száma:",
        "TOOLTIP_TEXT": "Az első reakció ideje {metricValue} ({conversationCount} beszélgetés alapján)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Megoldási idő",
        "DESC": "( Átlag )",
        "INFO_TEXT": "A számításhoz felhasznált beszélgetések száma:",
        "TOOLTIP_TEXT": "A megoldási idő {metricValue} ({conversationCount} beszélgetés alapján)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Megoldások száma",
        "DESC": "( Teljes )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Utolsó 7 nap"
      },
      {
        "id": 1,
        "name": "Utolsó 30 nap"
      },
      {
        "id": 2,
        "name": "Elmúlt 3 hónapban"
      },
      {
        "id": 3,
        "name": "Elmúlt 6 hónapban"
      },
      {
        "id": 4,
        "name": "Elmúlt 1 évben"
      },
      {
        "id": 5,
        "name": "Egyedi időszak"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Alkalmaz",
      "PLACEHOLDER": "Dátumtartomány kiválasztása"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "CSAT riportok",
    "NO_RECORDS": "Nem állnak rendelkezésre CSAT-felmérés válaszai.",
    "DOWNLOAD": "CSAT jelentés letöltése",
    "DOWNLOAD_FAILED": "Sikertelen a CSAT jelentés letöltése",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Ügynökök választása"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Kontakt",
        "AGENT_NAME": "Hozzárendelt ügynök",
        "RATING": "Értékelés",
        "FEEDBACK_TEXT": "Visszajelző komment"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Összes válasz",
        "TOOLTIP": "Összegyűjtött válaszok száma"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Elégedettségi pontszám",
        "TOOLTIP": "Pozitív válaszok teljes száma / Válaszok teljes száma * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Válaszarány",
        "TOOLTIP": "Válaszok teljes száma / Az elküldött CSAT felmérési üzenetek teljes száma * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot riportok",
    "METRIC": {
      "CONVERSATION_COUNT": {
        "LABEL": "Beszélgetések száma",
        "TOOLTIP": "A bot üzenetekkel rendelkező beszélgetések teljes száma"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Válaszok száma",
        "TOOLTIP": "A kimenő üzenetek teljes száma"
      },
      "MESSAGE_COUNT": {
        "LABEL": "AI válaszok száma",
        "TOOLTIP": "A bot által küldött válaszüzenetek teljes száma"
      },
      "COPILOT_COUNT": {
        "LABEL": "Előkészített válaszok száma",
        "TOOLTIP": "A bot által az ügynökök számára előkészített copilot javaslatok teljes száma"
      },
      "SUCCESS_RATE": {
        "LABEL": "AI által megoldva",
        "TOOLTIP": "Az AI által ügynöki átadás nélkül megoldott beszélgetések százaléka"
      },
      "RESOLVE_TIME": {
        "LABEL": "Megoldási idő",
        "TOOLTIP": "Medián idő az első ügyfélüzenettől az utolsó bot/ügynök üzenetig"
      },
      "TOTAL_CONVERSATIONS": {
        "LABEL": "No. of Conversations",
        "TOOLTIP": "Total number of conversations handled by the bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total Responses",
        "TOOLTIP": "Total number of responses sent by the bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Resolution Rate",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Handoff Rate",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      }
    },
    "GROUP_BY": {
      "LABEL": "Csoportosítás",
      "NONE": "Nincs csoportosítás",
      "INBOXES": "Postafiókok",
      "LABELS": "Címkék"
    },
    "GROUPED": {
      "CHART_TITLE": "Eloszlás csoportonként",
      "BACK_TO_ALL": "Mind megjelenítése",
      "TABLE": {
        "INBOX": "Postafiók",
        "LABEL": "Címke",
        "CONVERSATIONS": "Beszélgetések",
        "MESSAGES": "Üzenetek",
        "MESSAGES_TOOLTIP": "A kimenő üzenetek teljes száma",
        "AI_MESSAGES": "AI válaszok",
        "AI_MESSAGES_TOOLTIP": "Az AI válaszok teljes száma, majd a végfelhasználók pozitív és negatív értékeléseinek száma",
        "THUMBS_UP_TOOLTIP": "A végfelhasználók által pozitívan (hüvelykujj fel) értékelt AI válaszok száma",
        "THUMBS_DOWN_TOOLTIP": "A végfelhasználók által negatívan (hüvelykujj le) értékelt AI válaszok száma",
        "AI_PERCENTAGE": "AI %",
        "AI_PERCENTAGE_TOOLTIP": "AI válaszok százaléka a csoport összes üzenetéből",
        "PREPARED": "Előkészített válaszok",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "A csoporthoz tartozó üzenetek aránya az összes üzenetből",
        "BOT_RESPONSES": "AI válaszok %",
        "SUGGESTION_USED": "Használt válaszok",
        "SUGGESTION_USED_TOOLTIP": "Az ebben a csoportban előkészített válaszok azon aránya, amelyet az ügynökök használtak",
        "SUGGESTION_NOT_USED": "Nem használt válaszok",
        "SUGGESTION_NOT_USED_TOOLTIP": "Ebben a csoportban lévő üzenetek azon aránya, amelyekhez volt előkészített válasz, de nem került felhasználásra"
      },
      "NOTES": {
        "TITLE": "A metrikák kiszámításának módja",
        "CONVERSATIONS": "Azon beszélgetések száma, amelyekben legalább egy kimenő üzenet van a kiválasztott időszakban.",
        "MESSAGES": "A kiválasztott időszakban küldött kimenő (nem privát) üzenetek teljes száma. Ez tartalmazza az AI által generált és az ügynök által írt üzeneteket is.",
        "PERCENTAGE": "A csoport üzeneteinek aránya az összes csoport kimenő üzeneteihez képest.",
        "AI_MESSAGES": "Az AI bot által automatikusan küldött kimenő üzenetek száma (nem beleértve az ügynökök számára előkészített válaszokat). A zárójelben lévő számok azt mutatják, hány ilyen választ értékeltek a végfelhasználók pozitívan (hüvelykujj fel) és negatívan (hüvelykujj le).",
        "BOT_RESPONSES_PCT": "A csoport AI válaszainak aránya a csoport összes kimenő üzenetéhez képest.",
        "PREPARED": "Az AI bot által a kiválasztott időszakban ügynökök számára generált copilot javaslatok (előkészített válaszok) száma. Ezek csak az ügynökök számára látható privát üzenetek, és nem számítanak kimenő üzenetnek, így ez a szám nem feltétlenül korrelál az Üzenetek oszloppal.",
        "SUGGESTION_USED": "Az ebben a csoportban előkészített válaszok százaléka, amelyet az ügynökök használtak. Ez nem feltétlenül korrelál az Előkészített válaszok számával, mert tartalmazhatja a korábbi időszakokban generált javaslatokat is.",
        "SUGGESTION_NOT_USED": "Ebben a csoportban lévő kimenő üzenetek százaléka, ahol volt elérhető copilot javaslat, de az ügynök anélkül válaszolt, hogy felhasználta volna. Csak akkor számít, ha az ügynök ténylegesen elküldött egy választ. Ez nem feltétlenül korrelál az Előkészített válaszok számával, mert tartalmazhatja a korábbi időszakokban generált javaslatokat is."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Áttekintés",
    "LIVE": "Élő",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Beszélgetések megnyitása",
      "LOADING_MESSAGE": "Beszélgetési metrikák betöltése...",
      "OPEN": "Megnyitás",
      "UNATTENDED": "Figyelmen kívül hagyott",
      "UNASSIGNED": "Gazdátlan",
      "PENDING": "Függőben lévő"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Beszélgetés forgalom",
      "NO_CONVERSATIONS": "Nincsennek beszélgetések",
      "CONVERSATION": "{count} beszélgetés",
      "CONVERSATIONS": "{count} beszélgetés",
      "DOWNLOAD_REPORT": "Riport letöltése"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Ügynökök által kezelt beszélgetések",
      "LOADING_MESSAGE": "Ügynökök betöltése...",
      "NO_AGENTS": "Nincsennek ügynökök általi beszélgetések",
      "TABLE_HEADER": {
        "AGENT": "Ügynök",
        "OPEN": "Megnyitás",
        "UNATTENDED": "Figyelmen kívül hagyott",
        "STATUS": "Státusz"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "Minden csapat",
      "HEADER": "Beszélgetések csapatonként",
      "LOADING_MESSAGE": "Csapatmutatók betöltése...",
      "NO_TEAMS": "Nincs elérhető adat",
      "TABLE_HEADER": {
        "TEAM": "Csapat",
        "OPEN": "Megnyitás",
        "UNATTENDED": "Figyelmen kívül hagyott",
        "STATUS": "Státusz"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Ügynök státusz",
      "ONLINE": "Online",
      "BUSY": "Foglalt",
      "OFFLINE": "Offline"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "vasárnap",
    "MONDAY": "hétfő",
    "TUESDAY": "kedd",
    "WEDNESDAY": "szerda",
    "THURSDAY": "csütörtök",
    "FRIDAY": "péntek",
    "SATURDAY": "szombat"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA riportok",
    "NO_RECORDS": "Nincs olyan beszélgetés, amelyre SLA vonatkozik.",
    "LOADING": "SLA-adatok betöltése...",
    "DOWNLOAD_SLA_REPORTS": "SLA riportok letöltése",
    "DOWNLOAD_FAILED": "Nem sikerült letölteni az SLA riportokat",
    "DROPDOWN": {
      "ADD_FIlTER": "Szűrő hozzáadása",
      "CLEAR_ALL": "Összes törlése",
      "CLEAR_FILTER": "Szűrő törlése",
      "EMPTY_LIST": "Nincs találat",
      "NO_FILTER": "Nincs elérhető szűrő",
      "SEARCH": "Szűrő keresése",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA neve",
        "AGENTS": "Ügynök neve",
        "INBOXES": "Fiók név",
        "LABELS": "Cimke neve",
        "TEAMS": "Csapatnév"
      },
      "SLA": "SLA-szabályzat",
      "INBOXES": "Fiók",
      "AGENTS": "Ügynök",
      "LABELS": "Cimke",
      "TEAMS": "Csapat"
    },
    "WITH": "ügyfél:",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Teljesítési arány",
        "TOOLTIP": "A sikeresen teljesített SLA-k aránya a létrehozottakhoz képest"
      },
      "NO_OF_MISSES": {
        "LABEL": "Mulasztások száma",
        "TOOLTIP": "Az SLA-mulasztások teljes száma az adott időszakban"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Beszélgetések száma",
        "TOOLTIP": "Az SLA-val rendelkező beszélgetések teljes száma"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Szabályzat",
        "CONVERSATION": "Beszélgetés",
        "AGENT": "Ügynök"
      },
      "VIEW_DETAILS": "Részletek"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Részösszeg",
    "NO_TEAM": "Nincs csapat",
    "GROUP_BY_TEAMS": "Csoportosítás csapatok szerint",
    "INBOX": "Fiók",
    "AGENT": "Ügynök",
    "TEAM": "Csapat",
    "LABEL": "Címke",
    "TOTAL": "Összesen",
    "AVG_RESOLUTION_TIME": "Átl. megoldási idő",
    "AVG_FIRST_RESPONSE_TIME": "Átl. első reakció idő",
    "AVG_REPLY_TIME": "Átl. ügyfél-várakozási idő",
    "RESOLUTION_COUNT": "Megoldások száma",
    "CONVERSATIONS": "Beszélgetések száma",
    "OUTGOING_CHATS": "Kimenő csevegések",
    "OUTGOING_EMAILS": "Kimenő e-mailek",
    "PHONE_CALLS": "Telefonhívások",
    "INBOUND_CALLS": "Bejövő hívások",
    "OUTBOUND_CALLS": "Kimenő hívások",
    "TOTAL_ACTIVITIES": "Összes tevékenység",
    "ONLINE_TIME": "Online idő",
    "QUEUE_AVAILABLE_TIME": "Elérhető sor idő",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Az ügynök által küldött kimenő üzenetek száma",
      "OUTGOING_EMAILS": "Az ügynök által küldött kimenő e-mailek száma",
      "PHONE_CALLS": "Az ügynökhöz rendelt telefonhívások teljes száma (bejövő és kimenő hívások összege)",
      "TOTAL_ACTIVITIES": "Tevékenységek teljes száma: bejövő hívások + kimenő hívások + kimenő csevegések + kimenő e-mailek",
      "INBOUND_CALLS": "Az ügynökhöz rendelt bejövő telefonhívások száma",
      "OUTBOUND_CALLS": "Az ügynökhöz rendelt kimenő telefonhívások száma",
      "AVG_FIRST_RESPONSE_TIME": "Átlagos idő a beszélgetés létrehozásától az első ügynöki válaszig az ügynökhöz rendelt beszélgetésekben",
      "AVG_RESOLUTION_TIME": "Átlagos idő a beszélgetés létrehozásától a lezárásig az ügynökhöz rendelt beszélgetésekben",
      "AVG_REPLY_TIME": "Átlagos idő, amit az ügyfelek az üzenetük és az ügynök válasza között várnak az ügynökhöz rendelt beszélgetésekben",
      "ONLINE_TIME": "Az az idő, amíg az ügynök online vagy foglalt volt a kiválasztott időszakban",
      "QUEUE_AVAILABLE_TIME": "Az az idő, amíg az ügynök elérhető volt a telefonsorokban a kiválasztott időszakban"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Telefon jelentések",
    "DESCRIPTION": "Kövesse nyomon a telefonhívási metrikákat a bejövő és kimenő hívásokról részletes elemzéssel, ügynök vagy postafiók szerint csoportosítva az átfogó elemzéshez.",
    "AGENT_HEADER": "Telefon jelentések - Ügynökönként",
    "INBOX_HEADER": "Telefon jelentések - Postafiókonként",
    "DOWNLOAD_BUTTON": "Telefon jelentések letöltése",
    "DOWNLOAD_PHONE_REPORTS": "Telefon jelentések letöltése",
    "GROUP_BY": {
      "LABEL": "Csoportosítás",
      "AGENT": "Ügynök",
      "INBOX": "Postafiók"
    },
    "TABLE": {
      "AGENT_NAME": "Ügynök neve",
      "INBOX_NAME": "Postafiók neve",
      "TOTAL_CALLS": "Összesen",
      "INBOUND_CALLS": "Bejövő",
      "OUTBOUND_CALLS": "Kimenő",
      "FAILED_OUTBOUND_CALLS": "Sikertelen kimenő",
      "AVG_AGENT_HANDLED_DURATION": "Átlagos időtartam",
      "TOTAL_AGENT_HANDLED_DURATION": "Teljes időtartam",
      "AVG_RINGING_TIME": "Átlagos csengési idő",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Siker %",
      "UNIQUE_CALLERS": "Egyedi hívók",
      "UNIQUE_CALLED_CONTACTS": "Egyedi hívottak",
      "UNANSWERED_MISSED_CALLS": "Nem fogadott követés nélkül",
      "UNANSWERED_MISSED_PERCENTAGE": "Megválaszolatlan nem fogadott %",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Nem fogadott követés nélkül, elégtelenül visszahívott",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Nem fogadott követés nélkül, elégtelenül visszahívott %"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Az összes hívás száma (beleértve a nem kapcsolódottakat is)",
      "INBOUND_CALLS": "A kapcsolódott hívások száma",
      "OUTBOUND_CALLS": "Az összes kimenő hívás száma (beleértve a nem kapcsolódottakat is)",
      "FAILED_OUTBOUND_CALLS": "A nem kapcsolódott kimenő hívások száma",
      "AVG_AGENT_HANDLED_DURATION": "Az ügynökök által kezelt hívások átlagos időtartama",
      "TOTAL_AGENT_HANDLED_DURATION": "Az ügynökök által kezelt összes hívás teljes időtartama",
      "AVG_RINGING_TIME": "Átlagos idő, amíg a hívások csengtek, mielőtt fogadták volna őket",
      "CONNECTED_OUTBOUND_PERCENTAGE": "A sikeresen kapcsolódott kimenő hívások százaléka",
      "UNIQUE_CALLERS": "Az egyedi kapcsolattartók száma, akik bejövő hívást indítottak",
      "UNIQUE_CALLED_CONTACTS": "Az egyedi kapcsolattartók száma, akiket kimenő hívással hívtak",
      "UNANSWERED_MISSED_CALLS": "Azon nem fogadott hívások száma, amelyekre nem történt sikeres visszahívás (hívás kapcsolódott). Tartalmazhat olyan hívásokat, amelyek még a munkanapon belül kezelhetők",
      "UNANSWERED_MISSED_PERCENTAGE": "Az egyedi hívók százaléka, akiknek a hívásai követés nélkül maradtak (megválaszolatlan nem fogadott hívások / egyedi hívók)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Azon nem fogadott hívások száma, amelyekhez kevesebb mint 2 visszahívási kísérlet történt. Tartalmazhat olyan hívásokat, amelyek még a munkanapon belül kezelhetők",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Az egyedi hívók százaléka, akikhez kevesebb mint 2 visszahívási kísérlet történt ((nem fogadott követés nélkül - megfelelően kezelt) / egyedi hívók)"
    },
    "EMPTY_STATE": {
      "TITLE": "Nem áll rendelkezésre telefonhívási adat",
      "MESSAGE": "Nincsenek telefonhívások a kiválasztott időtartományban. Próbálja meg módosítani a szűrőket vagy az időtartományt."
    }
  }
}
